import React from 'react'
import './Sictl.css'

function Sictl() {
  return (
    <div className="main-sictl-container">
      {/* Hero section with background image and overlay */}
      <div className="sictl-hero">
        <div className="sictl-overlay">
          <h1>SICTL</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Content section with SICTL information */}
      <div className="sictl-content">
        <h2>Sialkot International Container Terminal Limited</h2>
        <p className="sictl-highlight">CENTREX Marine Services is a member of SICTL.</p>
        
        <div className="sictl-section">
          <h3>About SICTL</h3>
          <p>To establish a Multimodal Container Terminal at Sambrial, Sialkot is an innovative idea to expand benefits of "Sea Port" up to Business Community exists at land side of country. The idea will become the "Tug-Force" to DRAKE Ocean to land sides of Up-Country.</p>
        </div>
        
        <div className="sictl-section">
          <h3>Recognition</h3>
          <p>SICTL Multimodal container Terminal will be the new Horizon Spot for embracing Ocean Waters with land steps of Punjab Province anticipating the trust of idea FPCCI selected SICTL for its 1st achievement award 2012. The gold medal and certificate was awarded on June 22, 2013.</p>
          <p>Awarded to: M/s Sialkot International Container Terminal Limited</p>
        </div>
        
        <div className="sictl-link">
          <a href="https://sictl.org.pk/" target="_blank" rel="noopener noreferrer">
            Visit SICTL Official Website
          </a>
        </div>
      </div>
    </div>
  )
}

export default Sictl
